import * as React from 'react'
import { FC, useEffect } from 'react'
import { Form, useFormikContext } from 'formik'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { SoldServiceDayRangeSelect } from './SoldServiceDayRangeSelect'
import { FormValues } from './ContentBack'
import { useSelector } from 'react-redux'
import { selectClosedWonQueueSubmissionsSettings } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/slice'

export const SettingsForm: FC = () => {
  const { dirty, isSubmitting, isValid, setFieldValue } =
    useFormikContext<FormValues>()
  const widgetData = useSelector(selectClosedWonQueueSubmissionsSettings)
  useEffect(() => {
    setFieldValue('numberOfDays', widgetData.numberOfDays?.toString())
  }, [setFieldValue, widgetData.numberOfDays])

  return (
    <Form autoComplete="off">
      <Box mt={2}>
        <SoldServiceDayRangeSelect label="Number of Days" />
      </Box>

      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button
          color="primary"
          disabled={!dirty || isSubmitting || !isValid}
          type="submit"
          variant="contained"
        >
          Save Settings
        </Button>
      </Box>
    </Form>
  )
}

SettingsForm.displayName = 'SettingsForm'
